import Api from "../../config/ApiConfig";
import { ISubscriptionPostReq, IExtractorSubscriptionPostReq, ISubscriptionSearchParams } from "./types";

const apiUrls = {
  subscriptionURL: "api/v1/subscriptions",
  extractorURL: "api/v1/extractors"
};

export const getParam = (param: string | undefined, paramType: string) => {
  let str: string = "";
  if (param && param?.length > 0) str = `&${paramType}=${param}`;
  return str;
};

export const deleteSubscriptions = (param: string) =>
  Api.delete(apiUrls.subscriptionURL + `/${param}`)
    .then((response) => { return response })
    .catch((error) => { return error.response });

export const postSubscription = (payload: ISubscriptionPostReq) =>
  Api.post(apiUrls.subscriptionURL, payload)
    .then((response) => { return response; })
    .catch((error) => { return error.response; });

export const getSubscriptionDetails = (params: ISubscriptionSearchParams) =>
  Api.get(`${apiUrls.subscriptionURL}?` + getParam(params.subscriber, "subscriber") + getParam(params.taskConnectionId, "taskConnectionId") + getParam(params.batchCode, "batchCode"))
    .then((response) => { return response; })
    .catch((error) => { return error.response; });

export const postExtractorSubscription = (params: string, payload: IExtractorSubscriptionPostReq) =>
  Api.post(apiUrls.extractorURL + `/${params}` + '/subscriptions', payload)
    .then((response) => { return response; })
    .catch((error) => { return error.response; });
